<span class="flex flex-col">
  <span class="font-semibold">{{ criterion().label }}</span>
  @if (hasWeight()) {
    <span class="text-muted-color text-xs">
      {{ 'project.steps.providerResults.weight' | transloco }}:
      {{ weightPercent() | appNumber: '1.0-2' }} %
    </span>
  }
</span>
<span class="flex items-center gap-3 text-sm">
  @if (hasDeviation()) {
    <span [class]="deviationClass()" data-testid="rfp-individual-deviation">
      {{ 'project.steps.providerResults.rfpIndividual.deviation' | transloco: deviationParams() }}
    </span>
  }
  @if (scored()) {
    <span class="font-semibold">{{ criterion().percentage | appNumber: '1.0-0' }} %</span>
  } @else {
    <span class="text-muted-color">{{
      'project.steps.providerResults.rfpIndividual.notEvaluated' | transloco
    }}</span>
  }
</span>
